import {Fragment} from "react";
import Header from "./header/header";
import MainBlock from "./main-block/main-block";
import InfoBlock from "./info-block/info-block";
import TableBlock from "./table-block/table-block";
import PriceBlock from "./price-block/price-block";
import ContactBlock from "./contact-block/contact-block";
import Footer from "./footer/footer";


function App() {
    return (
        <Fragment>
            <Header/>
            <MainBlock />
            <InfoBlock />
            <TableBlock />
            <div className="wrapper-bg">
                <PriceBlock />
                <ContactBlock />
            </div>

            <Footer />
        </Fragment>
    );
}

export default App;
